import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect } from "react";
import { useState } from "react";
import { useDeleteAttachmentMutation } from "../../store/api/attachmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  showApproveDialog,
  showDeleteDialog,
  showHoldDialog,
  showRejectDialog,
} from "../../store/slice/dialogSlice";
import { GridToolbar } from "../GridToolbar/GridToolbar";

export default function AttachmentGrid({
  data,
  isLoading,
  columns,
  columnVisibility,
  setColumnVisibility,
  handleUpdateData,
  dynamicKey,
  page,
  handlePageChange,
  totalData,
  pageSize,
  height,
  hidePagination,
  hideSearch,
  showCheckbox,
  handleCellEdit,
  handleAddRow,
  tableDataCore,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Methods
  const handleDoubleClick = (params) => {
    switch (pathname) {
      case "/users":
        navigate(`/users/${params.row[dynamicKey]}`);
        break;
      case "/groups":
        navigate(`/groups/${params.row[dynamicKey]}`);
        break;
      case "/requests":
        navigate(`/requests/${params.row[dynamicKey]}`);
        break;
      case "/rfqs":
        navigate(`/rfqs/${params.row[dynamicKey]}`);
        break;
      case "/approval-stages":
        navigate(`/approval-stages/${params.row[dynamicKey]}`);
        break;
      case "/analysis-dimensions":
        navigate(`/analysis-dimensions/${params.row[dynamicKey]}`);
        break;
      case "/analysis-codes":
        navigate(`/analysis-codes/${params.row[dynamicKey]}`);
        break;
      case "/orders":
        navigate(`/orders/${params.row[dynamicKey]}`);
        break;
      case "/bids":
        navigate(`/bids/${params.row[dynamicKey]}`);
        break;
      case "/bid-comparison":
        navigate(`/bid-comparison/${params.row[dynamicKey]}`);
        break;
      default:
        break;
    }
  };

  const handleNavigation = (id) => {
    switch (pathname) {
      case "/users":
        navigate(`/users/${id}`);
        break;
      case "/groups":
        navigate(`/groups/${id}`);
        break;
      case "/requests":
        navigate(`/requests/${id}`);
        break;
      case "/approval-stages":
        navigate(`/approval-stages/${id}`);
        break;
      case "/analysis-dimensions":
        navigate(`/analysis-dimensions/${id}`);
        break;
      case "/analysis-codes":
        navigate(`/analysis-codes/${id}`);
        break;
      case "/orders":
        navigate(`/orders/${id}`);
        break;
      case "/bids":
        navigate(`/bids/${id}`);
        break;
      case "/bid-comparison":
        navigate(`/bid-comparison/${id}`);
        break;
      default:
        break;
    }
  };

  const handleRowDelete = () => {
    dispatch(showDeleteDialog());
    ;
  };

  const handleRowApprove = () => {
    dispatch(showApproveDialog());
  };

  const handleRowReject = () => {
    dispatch(showRejectDialog());
  };

  const handleRowHold = () => {
    dispatch(showHoldDialog());
  };

  const gridSize = useSelector((state) => state.dataGridSlice.size);

  const [tableData, setTableData] = useState();
  useEffect(() => {
    if (!isLoading) {
      setTableData(data?.data);
    }
  }, [isLoading, data]);

  //   const [deleteAttachment] = useDeleteAttachmentMutation(dynamicKey);

  return (
    <Box sx={{ height: height, width: "100%" }}>
      <DataGrid
        rows={tableData || []}
        columns={columns(
          handleNavigation,
          handleRowDelete,
          handleRowApprove,
          handleRowHold,
          handleRowReject
        )}
        onRowDoubleClick={handleDoubleClick}
        // onSelectionModelChange={(newSelection) => {
        //   handleUpdateData(
        //     tableData.filter((row) => newSelection.includes(row[dynamicKey]))
        //   );
        // }}
        onCellEditCommit={handleCellEdit}
        components={{
        //   Toolbar: () => <GridToolbar />,
        }}
        density={gridSize}
        loading={isLoading}
        columnVisibilityModel={columnVisibility}
        onColumnVisibilityModelChange={(newModel) =>
          setColumnVisibility(newModel)
        }
        getRowId={(row) => row[dynamicKey]}
        hideFooter
        checkboxSelection={showCheckbox}
      />
    </Box>
  );
}
